import { useState } from "react";
import { useSelector } from "react-redux";

import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto";
import { ExpandableTextarea } from "../../../components/ExpandableTextarea/ExpandableTextarea";
import { RootState } from "../../../state/store";

type WhoWorkedOnItCellProps = {
  stoppage: StoppageDto
  handleWhoWorkedOnItChange: (stoppage: StoppageDto) => Promise<void>
}

const WhoWorkedOnItCell: React.FC<WhoWorkedOnItCellProps> = ({ stoppage, handleWhoWorkedOnItChange }) => {
  const isShiftLocked = useSelector((state: RootState) => state.shift.isLocked);
  const [textState, setTextState] = useState<string>(stoppage.whoWorkedOnIt || '');

  return (
    <div className="w-full">
      <ExpandableTextarea
        disabled={isShiftLocked}
        value={textState}
        placeholder="Not Specified"
        onChange={(e) => {
          setTextState(e.target.value);
          stoppage.whoWorkedOnIt = e.target.value;
        }}
        onSubmit={async () => {
          await handleWhoWorkedOnItChange(stoppage);
        }}
      />
    </div>
  )
}

export default WhoWorkedOnItCell